/**
 * Animation Setup
 * 
 * Placeholder for animation libraries and custom animations.
 * This file is compiled but does nothing by default - add your animation library here.
 * 
 * To add an animation library (e.g., GSAP, Anime.js, Motion One):
 * 1. Install via bun: `bun add gsap` (or your chosen library)
 * 2. Import and initialize here
 * 3. Set up animation utilities and helpers
 * 
 * Example with GSAP:
 * ```javascript
 * import gsap from 'gsap';
 * import { ScrollTrigger } from 'gsap/ScrollTrigger';
 * 
 * gsap.registerPlugin(ScrollTrigger);
 * 
 * // Your animation code here
 * gsap.from('[data-animate]', {
 *   scrollTrigger: {
 *     trigger: '[data-animate]',
 *     start: 'top 80%',
 *   },
 *   opacity: 0,
 *   y: 30,
 * });
 * ```
 */

class Animations {
  constructor() {
    this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    // Ready for animations - add your initialization here
  }

  /**
   * Utility function for custom animations
   * Add your animation logic here when you install a library
   */
  animate(element, options) {
    console.warn('animate() called but no animation library is installed');
    return Promise.resolve();
  }
}

// Create instance for external use
const animationsInstance = new Animations();

// Export for external use
export default animationsInstance;

